/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const DATE_FORMAT_LONG = 'EEE, MMM d, yyyy';
export const DATE_FORMAT_LONG_LOWERCASE = 'eee, MMM d, yyyy';
export const DATE_FORMAT_NUMERIC = 'M/d/yyyy';
export const DATE_FORMAT_LONG_MONTH = 'MMMM dd, yyyy';
export const DATE_FORMAT_SHORT_MONTH = 'MMM dd, yyyy';
export const DATE_FORMAT_LL = 'MMMM d, yyyy';
export const DATE_FORMAT_LLL = 'MMMM d, yyyy h:mm a';
export const DATE_FORMAT_FULL = 'MMMM do yyyy, hh:mm:ss a';
export const DATE_FORMAT_SHORT = 'MM/dd';
export const DATE_FORMAT_FULL_WITH_ORDINAL = 'eee, MMMM do yyyy';
export const DATE_FORMAT_REPORT = 'yyyy-MM-dd';
export const DATE_FORMAT_REPORT_ISO = "yyyy-MM-dd'T'HH:mm:ss.SSSXXX";

export const INVALID_DATE = '0001-01-01T00:00:00Z';
